//libs
import get from 'lodash/get';

export const transformImages = (item: Listing.IProduct) => {
  const productImages = get(item, 'plp_pdp_bridge.images', []);
  if (productImages.length) productImages[0].url = item.imageUrl;
  return productImages;
};
